import { render, staticRenderFns } from "./UserGroupsIcon.vue?vue&type=template&id=0762e7b2"
import script from "./UserGroupsIcon.vue?vue&type=script&lang=js"
export * from "./UserGroupsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports